var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-row",class:{'group': _vm.isGroup }},[(this.label && this.label.length)?_c('label',{staticClass:"row-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }